import zionAxios from '@fs/zion-axios'
import axios from 'axios'

const giveAxios = Object.prototype.hasOwnProperty.call(zionAxios, 'create') ? zionAxios.create({}) : axios.create({})

export default giveAxios
